import Handler from '@/core/domain/usecase/handler';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import { Harvest } from '../../domain/model/harvest';

export interface ChangeHarvestRepository {
  (id: number, data: Harvest): Promise<Harvest>
}

const changeHarvestRepository = (axios: AxiosInstance): ChangeHarvestRepository => async (id: number, data: Harvest) => {
  try {
    const response: AxiosResponse = await axios.put(`/harvest/${id}`,
      data
    )
    return response.data
  } catch (err: any | AxiosError) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default changeHarvestRepository

